import Vue from 'vue'
import axios from 'axios'
import { processMatch } from '@/store/modules/matches/matchDetail'

// state
export const state = {
  isMatchLoading: false,
  all: {},
}

// getters
export const getters = {
  getMatch: ({ all }) => (matchId) => all[matchId] || null,
  getMatchPerformances: ({ all }) => (matchId) => {
    const match = all[matchId] || null
    return match.athlete_performance
  },
}
// mutations
export const mutations = {
  fetchMatchStarted(state) {
    state.isMatchLoading = true
  },
  fetchMatchSuccess(state, { matchId, match }) {
    Vue.set(state.all, matchId, processMatch(match, new Date()))
    state.isMatchLoading = false
  },
  fetchMatchFailed(state) {
    state.isMatchLoading = false
  },
}
// actions
export const actions = {
  async fetchMatch({ commit, getters }, { matchId }) {
    let match = getters.getMatch(matchId)
    if (match) {
      return match
    }
    try {
      commit('fetchMatchStarted')
      match = await axios.get(`match/${matchId}`)
      commit('fetchMatchSuccess', {
        matchId,
        match,
      })
    } catch (e) {
      console.log(e)
      commit('fetchMatchFailed')
    }
    return match
  },
}
